import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';

import { ToastrService } from 'core/toastr.service';
import { TagFileAttachmentService } from 'field-shared/tag-file-attachment.service';

export interface AttachDialogData {
  attachableId: string;
  attachableType: string;
}
@Component({
  selector: 'app-attach-dialog',
  templateUrl: 'attach-dialog.component.html',
})
export class AttachDialogComponent {
  file: File;
  isSaving = false;

  static open(dialog: MatDialog, config: MatDialogConfig<AttachDialogData>) {
    return dialog.open<AttachDialogComponent, AttachDialogData, boolean>(AttachDialogComponent, config);
  }

  constructor(
    private _attachmentApiSvc: TagFileAttachmentService,
    private _cd: ChangeDetectorRef,
    private _toastrService: ToastrService,
    public dialogRef: MatDialogRef<AttachDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AttachDialogData) { }

  choiceClicked(result: boolean): void {
    this.dialogRef.close(result);
  }

  onSaveClick() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    this._attachmentApiSvc.attachFileToTaggableLogbook(
      this.file,
      this.data.attachableId
    ).pipe(
      finalize(() => {
        this.isSaving = false;
        this._cd.markForCheck();
      })
    )
      .subscribe(
        res => {
          this._toastrService.success('File Saved');
          this.close(res);
        },
        err => {
          this._toastrService.error('Error saving file');
        }
      );
  }

  close(res: any = null) {
    this.dialogRef.close(res);
  }
}
